import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import { Amplify } from 'aws-amplify';
import App from './App';
import { applyAuthPersistence, awsConfig, getAuthPersistence } from './features/auth';
import { store } from './store/store'; // Import your Redux store
import reportWebVitals from './reportWebVitals';
import './index.css';

Amplify.configure(awsConfig);
applyAuthPersistence(getAuthPersistence());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    {/* Redux Provider should be at the top level */}
    <Provider store={store}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#eb4e2c', // global primary color (orange)
            colorInfo: '#222831', // custom secondary (used for Button type=default/info)
          },
          components: {
            Menu: {
              darkItemSelectedBg: '#eb4e2c', // active menu background
              darkItemBg: '#222831', // global primary color (orange)
            },
            Layout: {
              siderBg: '#222831', // global primary color (orange)
            },
            Button: {
              colorPrimary: '#eb4e2c',
              colorPrimaryHover: '#ec3c14ff',
            },
          },
        }}>
        <RouterProvider router={App} />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
